export default __webpack_public_path__ + "static/wap-gray-8ec3a8094cb9727d4b4a4667ad05ac6a.png";